export default class WebPage {

	onLoad() {

	}

}
